/* =========================================================
   AIELLO PDP Real Photos — carrossel + lightbox
   - Carrossel horizontal com setas e snap (desktop)
   - Swipe nativo (mobile)
   - Lightbox fullscreen com navegacao por teclado e click
   ========================================================= */

(function () {
  'use strict';

  function init(section) {
    if (section.__aielloPRPInit) return;
    section.__aielloPRPInit = true;

    var gallery = section.querySelector('.aiello-prp__gallery');
    var track = section.querySelector('[data-aiello-prp-track]');
    if (!gallery || !track) return;

    /* ===== Carrossel ===== */
    var prev = section.querySelector('[data-aiello-prp-prev]');
    var next = section.querySelector('[data-aiello-prp-next]');

    if (prev && next) {
      function scrollAmount() { return track.clientWidth * 0.75; }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      function updateButtons() {
        var atStart = track.scrollLeft <= 5;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
        prev.disabled = atStart;
        next.disabled = atEnd;
      }
      track.addEventListener('scroll', updateButtons);
      window.addEventListener('resize', updateButtons);
      updateButtons();
    }

    /* ===== Lightbox ===== */
    var lightbox = section.querySelector('[data-aiello-prp-lightbox]');
    var dataScript = section.querySelector('[data-aiello-prp-lightbox-data]');
    if (!lightbox || !dataScript) return;

    var images = [];
    try {
      images = JSON.parse(dataScript.textContent).images || [];
    } catch (_) { return; }
    if (!images.length) return;

    var lbImg = lightbox.querySelector('[data-aiello-prp-lb-img]');
    var lbClose = lightbox.querySelector('[data-aiello-prp-lb-close]');
    var lbPrev = lightbox.querySelector('[data-aiello-prp-lb-prev]');
    var lbNext = lightbox.querySelector('[data-aiello-prp-lb-next]');
    var lbCounter = lightbox.querySelector('[data-aiello-prp-lb-counter]');

    var currentIndex = 0;
    var lastTrigger = null;

    function showImage(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      currentIndex = index;
      if (lbImg) {
        lbImg.src = images[index];
        lbImg.alt = 'Foto ' + (index + 1);
      }
      if (lbCounter) lbCounter.textContent = (index + 1) + ' / ' + images.length;
    }

    function openLightbox(index) {
      lastTrigger = document.activeElement;
      showImage(index);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (lbClose) lbClose.focus(); }, 50);
    }

    function closeLightbox() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    }

    section.querySelectorAll('[data-aiello-prp-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var idx = parseInt(trigger.getAttribute('data-aiello-prp-index') || '0', 10);
        openLightbox(idx);
      });
    });

    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    if (lbPrev) lbPrev.addEventListener('click', function () { showImage(currentIndex - 1); });
    if (lbNext) lbNext.addEventListener('click', function () { showImage(currentIndex + 1); });

    // Click no fundo fecha
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });

    // Teclado
    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
      else if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    });
  }

  function bootstrap() {
    document.querySelectorAll('.aiello-prp').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Re-init no theme editor quando section recarrega
  document.addEventListener('shopify:section:load', bootstrap);
})();
